"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsButtonNavigate = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _material = require("@mui/material");
var _reactRouterDom = require("react-router-dom");
const _excluded = ["route", "text"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/**
 * A navigation button component that uses Material-UI's `Button` for routing.
 * It supports configurations for text-only, icon-only, or a combination of text and icon.
 *
 * @param {Object} props - The properties passed to the component.
 * @param {string} props.route - The route to navigate to when the button is clicked.
 * @param {string} props.text - The text to display on the button.
 * @param {string} [props.variant] - The variant of the button (e.g., 'contained', 'outlined', 'text').
 * @param {string} [props.color] - The color of the button (e.g., 'default', 'primary', 'secondary').
 * @param {boolean} [props.disabled] - If `true`, the button will be disabled.
 * @param {boolean} [props.fullWidth] - If `true`, the button will take up the full width of its container.
 * @param {boolean} [props.startIcon] - The icon to display at the start of the button.
 * @param {boolean} [props.endIcon] - The icon to display at the end of the button.
 * @param {function} [props.onClick] - The function to call when the button is clicked.
 * @param {Object} [props.sx] - The system props to apply custom styles (from Material-UI's `sx` prop).
 * @returns {React.Element} A Material-UI `Button` that navigates to the specified route.
 */
const DmsButtonNavigate = _ref => {
  let {
      route,
      text
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(_material.Button, _extends({
    component: _reactRouterDom.Link,
    to: route
  }, props), text);
};
exports.DmsButtonNavigate = DmsButtonNavigate;
DmsButtonNavigate.propTypes = _objectSpread({
  route: _propTypes.default.string.isRequired,
  text: _propTypes.default.string.isRequired
}, _material.Button.propTypes);